import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesStoreOption = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    inputValFranchisee: '',
    inputValAreaManager: '',
    inputValArea: '',
    inputValOriginalTag: {
      a: '',
      b: '',
      c: '',
      d: '',
      e: '',
    },
  },
  getters: {
    inputValFranchisee(state) {
      return state.inputValFranchisee
    },
    inputValAreaManager(state) {
      return state.inputValAreaManager
    },
    inputValArea(state) {
      return state.inputValArea
    },
    inputValOriginalTag(state) {
      return state.inputValOriginalTag
    },
  },
  mutations: {
    readStoreOption(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    readStoreOptionSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
      state.inputValFranchisee = payload.data.attributes.franchisee?.name
      state.inputValAreaManager = payload.data.attributes.user_company?.name
      state.inputValArea = payload.data.attributes.area?.name
      state.inputValOriginalTag.a = payload.data.attributes.original_tag_group_a_tag?.name
      state.inputValOriginalTag.b = payload.data.attributes.original_tag_group_b_tag?.name
      state.inputValOriginalTag.c = payload.data.attributes.original_tag_group_c_tag?.name
      state.inputValOriginalTag.d = payload.data.attributes.original_tag_group_d_tag?.name
      state.inputValOriginalTag.e = payload.data.attributes.original_tag_group_e_tag?.name
    },
    readStoreOptionFailure(state) {
      state.loading = false
      state.loadError = true
    },
    updateStoreOption(state) {
      state.loading = true
    },
    updateStoreOptionSuccess(state) {
      state.loading = false
    },
    updateStoreOptionFailure(state) {
      state.loading = false
    },
    setFranchiseeId(state, franchiseeId) {
      if (!state.data.attributes) {
        state.data.attributes = {}
      }
      state.data.attributes.franchisee_id = franchiseeId
    },
    setUserCompanyId(state, userCompanyId) {
      if (!state.data.attributes) {
        state.data.attributes = {}
      }
      state.data.attributes.user_company_id = userCompanyId
    },
    setAreaId(state, areaId) {
      if (!state.data.attributes) {
        state.data.attributes = {}
      }
      state.data.attributes.area_id = areaId
    },
    setOriginalTagGroupTagId(state, payload) {
      if (!state.data.attributes) {
        state.data.attributes = {}
      }
      state.data.attributes[`original_tag_group_${payload.kind}_tag_id`] = payload.tagId
    },
    setFranchiseeVal(state, val) {
      state.inputValFranchisee = val
    },
    setUserCompanyVal(state, val) {
      state.inputValAreaManager = val
    },
    setAreaVal(state, val) {
      state.inputValArea = val
    },
    setOriginalTagGroupTagVal(state, payload) {
      state.inputValOriginalTag[payload.kind] = payload.val
    },
  },
  actions: {
    readStoreOption({ commit }, { company_uuid, store_uuid }) {
      commit('readStoreOption')
      axios
        .get('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/options.json', {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          commit('readStoreOptionSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreOptionFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    updateStoreOption({ commit, state }, {company_uuid, store_uuid}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('updateStoreOption')
      const payload = {
        store_option: {
          franchisee_id: state.data.attributes.franchisee_id,
          user_company_id: state.data.attributes.user_company_id,
          area_id: state.data.attributes.area_id,
          code: state.data.attributes.code
        },
        original_tag_ids: {
          original_tag_group_a_tag_id: state.data.attributes.original_tag_group_a_tag_id,
          original_tag_group_b_tag_id: state.data.attributes.original_tag_group_b_tag_id,
          original_tag_group_c_tag_id: state.data.attributes.original_tag_group_c_tag_id,
          original_tag_group_d_tag_id: state.data.attributes.original_tag_group_d_tag_id,
          original_tag_group_e_tag_id: state.data.attributes.original_tag_group_e_tag_id,
        },
      }

      axios
        .put('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/options.json', payload, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(() => {
          commit('updateStoreOptionSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.storeOption.modelName') }) }, { root: true })
        })
        .catch(err => {
          console.error(err)
          commit('updateStoreOptionFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    setFranchiseeId({ commit }, franchiseeId) {
      commit('setFranchiseeId', franchiseeId)
    },
    setUserCompanyId({ commit }, userCompanyId) {
      commit('setUserCompanyId', userCompanyId)
    },
    setAreaId({ commit }, areaId) {
      commit('setAreaId', areaId)
    },
    setOriginalTagGroupTagId({ commit }, payload) {
      commit('setOriginalTagGroupTagId', payload)
    },
    setFranchiseeVal({ commit }, val) {
      commit('setFranchiseeVal', val)
    },
    setUserCompanyVal({ commit }, val) {
      commit('setUserCompanyVal', val)
    },
    setAreaVal({ commit }, val) {
      commit('setAreaVal', val)
    },
    setOriginalTagGroupTagVal({ commit }, payload) {
      commit('setOriginalTagGroupTagVal', payload)
    },
  }
}
